function fileUploadInput() {
	return {
		restrict: "A",
		scope: {
			onFileSelected: "&"
		},
		link: (scope, element) => {
			const handler = (event) => {
				const file = event.target.files && event.target.files[0];
				scope.$apply(() => scope.onFileSelected({ file }));
				element.val("");
			};

			element.on("change", handler);

			scope.$on("$destroy", () => {
				element.off("change", handler);
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.file-upload-input", [])
	.directive("fileUploadInput", fileUploadInput).name;
